__turbopack_context__.v({
  "body": "recipe-card-module__GcP6KW__body",
  "card": "recipe-card-module__GcP6KW__card",
  "cardLink": "recipe-card-module__GcP6KW__cardLink",
  "desc": "recipe-card-module__GcP6KW__desc",
  "dietwrap": "recipe-card-module__GcP6KW__dietwrap",
  "eyebrow": "recipe-card-module__GcP6KW__eyebrow",
  "feature": "recipe-card-module__GcP6KW__feature",
  "foot": "recipe-card-module__GcP6KW__foot",
  "image": "recipe-card-module__GcP6KW__image",
  "kcal": "recipe-card-module__GcP6KW__kcal",
  "media": "recipe-card-module__GcP6KW__media",
  "removeFloat": "recipe-card-module__GcP6KW__removeFloat",
  "saveFloat": "recipe-card-module__GcP6KW__saveFloat",
  "savedIn": "recipe-card-module__GcP6KW__savedIn",
  "savedInIcon": "recipe-card-module__GcP6KW__savedInIcon",
  "status": "recipe-card-module__GcP6KW__status",
  "time": "recipe-card-module__GcP6KW__time",
  "timeIcon": "recipe-card-module__GcP6KW__timeIcon",
  "title": "recipe-card-module__GcP6KW__title",
  "variantpos": "recipe-card-module__GcP6KW__variantpos",
});
